/**
 * Shared constants for the MADS design system
 */

/**
 * Primary font family for React Native components
 * Note: This is a simplified version of fonts.default from @indeed/ifl-tokens/react-native
 * since React Native doesn't support font fallbacks in the same way as web
 */
export const FONT_FAMILY = 'Indeed Sans';

export type CommonSize = 'sm' | 'md' | 'lg';

export const COMMON_SIZES: CommonSize[] = ['sm', 'md', 'lg'];
